<script setup lang="ts">
  import type { FormElement, NumberInputProperties } from '../../../model/form.types';
  import { useNumberInputElement } from '../../../model/useNumberInputElement';
  import { FORM_FIELD_CHARACTER_LIMITS } from '../../../lib/form-field-character-limits';

  interface Props {
    element: FormElement & { properties: NumberInputProperties };
  }

  const props = defineProps<Props>();
  const {
    inputValue,
    isLabelLeft,
    inputClasses,
    labelClasses,
    labelStyles,
    containerStyles,
    isEditable,
    handleNumberInput,
    handleNumberKeydown,
    handleNumberPaste,
    handleNumberBlur,
    persistValue,
  } = useNumberInputElement(() => props.element);
</script>

<template>
  <div
    class="form-builder-simple-input"
    :class="{ 'label-left': isLabelLeft }"
    :style="containerStyles"
  >
    <label
      :for="`input-${element.id}`"
      :class="labelClasses"
      :style="labelStyles"
    >
      {{ element.properties.label }}
    </label>
    <input
      :id="`input-${element.id}`"
      :value="inputValue"
      type="text"
      inputmode="decimal"
      :maxlength="FORM_FIELD_CHARACTER_LIMITS.VALUE"
      :name="element.properties.name"
      :placeholder="element.properties.placeholder"
      :required="element.properties.required"
      :aria-label="element.properties.label || element.properties.name"
      :readonly="!isEditable"
      :class="inputClasses"
      @keydown="handleNumberKeydown($event, persistValue)"
      @paste="handleNumberPaste($event, persistValue)"
      @input="handleNumberInput($event, persistValue)"
      @blur="handleNumberBlur($event, persistValue)"
    >
  </div>
</template>

<style scoped>
  @import './form-builder-simple-input.css';
</style>
